
import { defineComponent, SetupContext, computed, ref } from "vue";
import NativeClient from "@/client/native-client";
import LoadingPullToRefresh from "@/components/common/LoadingPullToRefresh.vue";

export default defineComponent({
  name: "PullToRefresh",
  components: { LoadingPullToRefresh },
  props: {
    /** トップマージン 単位はrem */
    topMargin: {
      type: Number,
      default: 0
    }
  },
  setup(props, context: SetupContext) {
    const topClass = "pulltorefresh";
    const indicatorThreshold = 60;
    const refreshThreshold = 300;
    const styleTop = computed(() => {
      return { 'padding-top': `${props.topMargin}rem` };
    });
    const topLoadingPosition = 0;
    let touchStartPosition = 0;
    let isRefreshing = false;
    let isRefreshingDisplay = false;
    const refPullToRefresh = ref(false);
    const processPullToRefresh = (isRefreshing: boolean) => {
      refPullToRefresh.value = isRefreshing;
      if (isRefreshing) {
        NativeClient.sendDebugLog("PullToRefresh detect refresh");
      }
    };
    const touchStart = (event: TouchEvent) => {
      NativeClient.sendDebugLog("PullToRefresh touchStart");
      touchStartPosition = event.touches[0].pageY;
    };
    const touchMove = (event: TouchEvent) => {
      NativeClient.sendDebugLog("PullToRefresh touchMove");
      const currentY = event.touches[0].pageY;
      let targetElement = document.elementFromPoint(event.touches[0].pageX, event.touches[0].pageY);
      while (targetElement != null && targetElement!.className != topClass) {
        targetElement = targetElement.parentElement;
      }
      if (targetElement == null || isRefreshing == true) {
        NativeClient.sendDebugLog("PullToRefresh moveEvent no target or already refreshing");
        return;
      }
      if (targetElement!.scrollTop === 0) {
        const currentDifference = currentY - touchStartPosition;
        let actualRefreshThreshold = refreshThreshold;
        if (NativeClient.isIOS()) {
          // iOSならば1/3にする（調整結果）
          actualRefreshThreshold = actualRefreshThreshold / 3;
          NativeClient.sendDebugLog("PullToRefresh moveEvent iOS");
        }
        if (actualRefreshThreshold < currentDifference) {
          NativeClient.sendDebugLog("PullToRefresh moveEvent refreshing start");
          isRefreshing = true;
          context.emit("refresh");
          window.setTimeout(() => {
            processPullToRefresh(false);
          }, 200);
        } else if (indicatorThreshold < currentDifference && !isRefreshingDisplay) {
          NativeClient.sendDebugLog("PullToRefresh moveEvent refreshing display start");
          isRefreshingDisplay = true;
          processPullToRefresh(true);
        }
      }
    };
    const touchEnd = () => {
      NativeClient.sendDebugLog("PullToRefresh touchEnd");
      isRefreshing = false;
      isRefreshingDisplay = false;
      processPullToRefresh(false);
    };
    const showPullToRefresh = computed(() => {
      if (refPullToRefresh.value) {
        return true;
      }
      return false;
    });

    return {
      styleTop,
      touchStart,
      touchMove,
      touchEnd,
      showPullToRefresh,
      topLoadingPosition
    };
  }
});
